import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import ClearIcon from "@material-ui/icons/Clear";
import { IconButton } from "@material-ui/core";


const CssTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: 0,
    },
    '& .MuiInputLabel-formControl': {
      top:'-2px',
      color:'var(--cor-placeholder)'
    },
    '& label.Mui-focused': {

      color:'var(--cor-fonte-hover)',
    },
    '& .MuiInput-underline:after': {
      borderColor: '#389492',
      borderRadius: '4px'
    },
    
    '& .MuiOutlinedInput-root': {
    
    color:'var(--cor-fonte-hover)',
      '& fieldset': {
        borderColor: '#389492',
        borderRadius: '4px'
      },
      '&:hover fieldset': {
        borderColor: '#389492',
        borderRadius: '4px',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#389492',
        borderRadius: '4px'
      },
      height: '30px',
    },
  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    marginRight: '6px',
    marginBottom: '10px'
  },
}));

export default function CustomizedInputs(props) {
  const classes = useStyles();

  return (
    <>
      <CssTextField
        className={classes.margin}
        label={props.label}
        variant={props.variant}
        id={props.id}
        size={props.size}
        name={props.name}
        autoFocus={false}
        inputProps={{
          maxLength: props.maxLength,
          pattern: props.pattern,
          disabled: props.disabled
        }}

        InputProps= {props.noClear ? {} : { 
          endAdornment: (
            <IconButton style={{ background: 'transparent', color: (document.documentElement.style.getPropertyValue('var(--cor-fonte-hover)'))}} onClick={() => props.onChange({target: {name: props.name, value: null}})} disabled={props.disabled}>
              <ClearIcon/>
            </IconButton>
          )
        }}
        InputLabelProps={{ 
          shrink: true
        }}
        {...props}
        // type="date"
        type= {(props.time==='S') ? "datetime-local" : "date"}
      />
    </>
  );
}